import React, { useState } from "react";
import clsx from "clsx";
import axios from "axios"
import { ThemeProvider } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import IconButton from "@material-ui/core/IconButton";
import { apollo_useStyles, apollo_theme, Copyright, drawerWidth, menuButtonWidth, menuButtonMarginLeft } from "../atom/Apollo_styles";
import { SelectAccountModal } from "../organism/AccountSelectDialog";
import { SystemManagementMenu } from "../pages/SYSTEMMNG/SystemManagementMenu";
import { NotificationModal } from "../pages/SYSTEMMNG/NotificationDialog";
import { UserPofileModal } from "../pages/SYSTEMMNG/UserProfileDialog";
import { SegmentMenu } from "../pages/SYSTEMMNG/SegmentMenu";
import { ManualMenu } from "../pages/SYSTEMMNG/ManualMenu";

import { ApolloContext } from "../atom/Apollo_Context";
import LinearProgress from '@material-ui/core/LinearProgress';
import { ApolloMessage } from "../atom/Apollo_Mesasge";
import {
  ApolloAuthorization,
  ApolloUserProfileAuth,
  APOLLO_SYSTEM_ADMIN,
  APOLLO_GROUP_OPERATOR,
  APOLLO_GROUP_ADMIN,
  APOLLO_PROFILE_SYSTEM_ADMIN,
  APOLLO_PROFILE_SYSTEM_OPERATOR,
  APOLLO_GROUP_READER,
  APOLLO_SYSTEM_OPERATOR,
  IsAuthorization,
} from "../atom/Apollo_Authorization";

import {
  accountdetailapollo_path,
  adclienticonsapollo_path,
  crassets_path,
  events_path,
  audiences_path,
  setpoints_path,
  csvupload_path,
  customsegmentposeidon_path,
  reports_path,
  home_path,
  isummary_path,
  adgroups_path,
  advertisements_path,
  past_report_path,
  apollo_account_platform_menu_path,
  review_csv_path
} from "../atom/Apollo_links";
import { MenuBarData } from "../atom/Apollo_MenuBar";
import { ApolloSideMenu } from "../molecule/Apollo_SideMenu";
import { SelectMenu, IsAdClientIconSelectableMenu } from "../molecule/Apollo_SelectMenu";
import { ApolloAxios } from "../atom/Apollo_ApiRequest3";

export interface GenericTemplateProps {
  children: React.ReactNode;
  title: string;
}

/*
   画面名：標準テンプレート
 */
const GenericTemplate: React.FC<GenericTemplateProps> = ({
  children,
  title,
}) => {
  const classes = apollo_useStyles();
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);
  const accountgroupid = state.current.accountGroupId;
  const accountid = state.current.accountId;
  const mailAddress = state.userprofile.mailAddress;
  const [path, setPath] = React.useState("");
  const [segmentFlg, setSegmentFlg] = React.useState(false);
  const [adClientIconFlg, setAdClientIconFlg] = React.useState(false);
  const [zeusAccountId, setPlatformAccountId] = useState("");
  const [isZeusPageDisplay, setZeusPageDisplay] = useState(false);

  const [loading, setLoading] = React.useState(true);

  const [open, setOpen] = React.useState(state.userprofile.sideMenuControl ? true : false);

  const totalWidth = drawerWidth + menuButtonWidth + menuButtonMarginLeft; // サイドメニュー + 開閉ボタンの幅

  React.useEffect(() => {
    if (state.userprofile.systemAdmin > 0 ||
      (state.current.roleAuthorization > APOLLO_GROUP_READER &&
        (state.current.geoSegment === 2 || state.current.customSegment === 2))) {
      setSegmentFlg(true);
    }

    const fetchData = async () => {
      try {
        setLoading(true);

        const path = `${process.env.REACT_APP_API_ENDPOINT}${apollo_account_platform_menu_path}/${accountid}`;

        const response = await ApolloAxios.get(path, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          },
        });

        const data = response.data;
        console.log(data);

        // menuIdが1かつuseStatusが1のpfAccountIdを取得
        const targetEntry = data.result.find(
          (entry: any) => entry.menuId === 1 && entry.useStatus === 1
        );

        const zeusAccountId = targetEntry?.pfAccountId;

        setPlatformAccountId(zeusAccountId);
        setZeusPageDisplay(zeusAccountId ? true : false)

      } catch (error) {
        setZeusPageDisplay(false)
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accountid, state.accesstoken]);

  // サイドメニュー幅がブラウザ幅の50％を超えた時、サイドメニューを折りたたむ
  React.useEffect(() => {
    const handleResize = () => {
      if (totalWidth > window.innerWidth / 2) {
        setOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // TODO: DB or Contextから取得 (カスタムセグメント操作権限)
  let permissionCustomSegment = 2;

  const menuList: MenuBarData[] = [
    {
      display: true,
      type: 1,
      link: home_path,
      title: "ホーム",
      img: "/icon/nav_24.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: true,
      type: 3,
      link: "",
      title: "アカウント情報",
      img: "/icon/nav_25.png",
      color: "#4B4B4B",
      subMenuList: [
        {
          display: true,
          link: accountid === 0 ? home_path : accountdetailapollo_path + accountgroupid + "/" + accountid,
          title: "アカウント詳細",
          color: "#4B4B4B",
        },
        {
          display: adClientIconFlg,
          link: accountid === 0 ? home_path : adclienticonsapollo_path + accountgroupid + "/" + accountid,
          title: "広告主アイコン",
          color: "#4B4B4B",
        },
      ],
    },
    {
      display: true,
      type: 1,
      link: accountid === 0 ? home_path : isummary_path,
      title: "キャンペーン",
      img: "/icon/nav_23.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: true,
      type: 2,
      link: adgroups_path,
      title: "広告グループ",
      img: "/icon/nav_22.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: true,
      type: 2,
      link: advertisements_path,
      title: "広告",
      img: "/icon/nav_20.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: isZeusPageDisplay,
      type: 1,
      link: review_csv_path + "zeus/" + accountgroupid + "/" + accountid + "/" + zeusAccountId,
      title: "審査結果ダウンロード\n（パフォーマンス広告）",
      img: "/icon/nav_26.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_PROFILE_SYSTEM_OPERATOR),
      type: 2,
      link: csvupload_path,
      title: "一括処理アップロード",
      img: "/icon/nav_21.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: true,
      type: 3,
      link: "",
      title: "レポート管理",
      img: "/icon/nav_14.png",
      color: "#4B4B4B",
      subMenuList: [
        {
          display: true,
          link: reports_path,
          title: "新規レポート作成／一覧",
          color: "#4B4B4B",
        },
        {
          display: true,
          link: past_report_path,
          title: "過去分レポート一覧",
          color: "#4B4B4B",
        },
      ],
    },
    {
      display: true,
      type: 2,
      link: crassets_path,
      title: "広告アセット",
      img: "/icon/nav_15.png",
      subMenuList: [],
      color: "#4B4B4B",
    },
    {
      display: true,
      type: 3,
      link: "",
      title: "トラッキング",
      img: "/icon/nav_16.png",
      color: "#4B4B4B",
      subMenuList: [
        {
          display: true,
          link: accountid === 0 ? home_path : events_path,
          title: "イベント一覧",
          color: "#4B4B4B",
        },
        {
          display: true,
          link: accountid === 0 ? home_path : audiences_path,
          title: "オーディエンス一覧",
          color: "#4B4B4B",
        },
        {
          display: true,
          link: accountid === 0 ? home_path : setpoints_path,
          title: "測定ポイント一覧",
          color: "#4B4B4B",
        },
      ],
    },
    {
      display: true,
      type: 3,
      link: "",
      title: "広告アカウント",
      img: "/img/poseidon/adaccount_black.png",
      color: "#4B4B4B",
      subMenuList: [
        {
          display: true,
          link: accountid === 0 ? home_path : customsegmentposeidon_path,
          title: "カスタムセグメント一覧",
          color: "#4B4B4B",
        },
        // {
        //   display: true,
        //   link: accountid === 0 ? home_path : geosegmentposeidon_path,
        //   title: "ジオセグメント一覧",
        // },
        // {
        //   display: state.current.roleAuthorization >= APOLLO_GROUP_OPERATOR ? true : false,
        //   link: accountid === 0 ? home_path : userlistposeidon_path,
        //   title: "ユーザーリスト一覧",
        // },
        // {
        //   display: state.current.roleAuthorization >= APOLLO_GROUP_OPERATOR ? true : false,
        //   link: accountid === 0 ? home_path : userlisteditposeidon_path + "0",
        //   title: "ユーザーリスト作成",
        // },
      ],
    },
  ];

  return (
    <ThemeProvider theme={apollo_theme}>
      <IsAdClientIconSelectableMenu
        adClientIconFlg={adClientIconFlg}
        setAdClientIconFlg={setAdClientIconFlg}
        isDisplayErrMsg={false}
      />
      <div className={classes.mainroot}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={clsx(classes.appBar, open && classes.appBarShift)}
          variant="outlined"
        >
          <Toolbar className={classes.toolbar}>
            <Link to="#" className={classes.link}>
              <img
                src={`/logo/${process.env.REACT_APP_ENV}/logo_docomo.png`}
                alt="Apollo"
                className={classes.logo}
              />
            </Link>
            <div className={classes.account}>
              <SelectAccountModal />
            </div>
            <div className={classes.sectionDesktop}>
              <ManualMenu />
              <SystemManagementMenu />
              <NotificationModal />
              {segmentFlg ? <SegmentMenu /> : ""}
            </div>
            <div className={classes.userInfo}>
              ユーザーID<br />
              {mailAddress}
            </div>
            <UserPofileModal setOpen={setOpen} />
          </Toolbar>
        </AppBar>

        <SelectMenu pathTop={path} pathEnd={""} open={openDialog} setOpen={setOpenDialog} />

        {loading ? (
          <LinearProgress />
        ) : (
          <Drawer
            variant="permanent"
            classes={{
              paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
          >
            <ApolloSideMenu list={menuList} open={open} setPath={setPath} setOpen={setOpenDialog} />
          </Drawer>
        )}

        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          className={clsx(
            classes.menuButton,
            open && classes.menuButtonHidden
          )}
        >
          <ChevronRightIcon
            className={classes.menuButtonIcon}
          />
        </IconButton>

        <IconButton
          edge="start"
          color="inherit"
          onClick={handleDrawerClose}
          className={clsx(
            classes.menuButton,
            (!open) && classes.menuButtonHidden
          )}
        >
          <ChevronLeftIcon
            className={classes.menuButtonIcon}
          />
        </IconButton>

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="xl" className={classes.container}>
            {data.loading && <LinearProgress />}
            <Typography
              component="h2"
              variant="h5"
              color="inherit"
              noWrap
              className={classes.pageTitle}
            >
              {title}
            </Typography>
            {children}
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    </ThemeProvider>
  );
};

export default GenericTemplate;
